const initState = {
    authError: null
}

export const user = (state = initState, action) => {

    switch (action.type) {
        case 'GET_ADS':
            return {
                ...state,
                ads: action.ads,
                authError: null
            }
        case 'CREATE_PREFERENCES_USER':
            return {
                ...state,
                uid: action.uid,
                authError: null
            }
        case 'UPDATE_PREFERENCES_USER':
            return {
                ...state,
                uid: action.uid,
                authError: null
            }
        case 'GET_SHIELD_POINTS':
            return {
                ...state,
                data_points: action.data_points,
                authError: null
            }
        case 'GET_DATA_PROFILE':
            return {
                ...state,
                data: action.data,
                authError: null
            }
        case 'GET_DATA_PREFERENCES': 
            return {
                ...state,
                result: action.result,
                authError: null
            }
        case 'GET_DATA_PREFERENCES_FAILED': 
            return {
                ...state,
                authError: action.err
            }
        case 'GET_PREFERENCES_PRIVACITY': 
            return {
                ...state,
                dataPrivacity: action.dataPrivacity,
                authError: null
            }
        case 'UPDATE_PREFERENCES_PRIVACITY_USER': 
            return {
                ...state,
                authErrorPrefPrivacity: null
            }

        default:
            return state
    }

}